import React from 'react';
import 'partial/EmailNotification/EmailNotificationView.scss';
import classnames from 'classnames';
import { useScrollToTop } from 'hook/helper.hook';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { NotificationIcon } from 'components/Notification/Notification';
import { ReactComponent as CloseIcon } from 'style/_assets/icons/close.svg';
import { Toggle } from 'components/form/Toggle';

export const OverviewNotificationView = ({ ...props }) => {
  useScrollToTop();
  const { showSuccess, isAnimating } = props;
  const initialClassName = classnames({
    'collapse padT0': isAnimating,
  });

  if (showSuccess === null) {
    const customClassName = classnames(
      initialClassName,
      'emailNotification padT48 padB16 m-padT24 m-padLR16 m-padB8',
    );
    return (
      <div className="t-bgWhite">
        <div className={customClassName}>
          <EmailNotificationView
            type="info"
            title={`Welcome back, ${props.firstName}!`}
            description="Stay updated with credit monitoring alerts and personalized offers."
            hasToggle={true}
            closable={true}
            {...props}
          />
        </div>
      </div>
    );
  } else if (showSuccess) {
    const customClassName = classnames(
      initialClassName,
      'emailNotification padT48 padB24 m-padT24 m-padLR16 m-padB8',
    );
    return (
      <div className="t-bgWhite">
        <div className={customClassName}>
          <EmailNotificationView
            type="success"
            title="Email notifications have been turned on"
            description="You can always change your email preferences in the notification settings."
            {...props}
          />
        </div>
      </div>
    );
  } else {
    return '';
  }
};

const EmailNotificationView = ({
  title,
  description,
  type,
  page,
  hasToggle,
  toggleStatus,
  closable,
  onClickToggle,
  onClickClose,
  ...props
}) => {
  const toggleText = toggleStatus ? 'YES' : 'NO';
  const isProfile = page === 'profile';
  return (
    <FlexContainer
      className={classnames(
        'emailNotificationInner border-rad4px pad12',
        `box-${type}`,
      )}
    >
      <div className="padR10">
        <NotificationIcon type={type} />
      </div>
      <FlexContainer className="flex-column width100 padT2">
        {title && <div className="Subtitle-2 margB4">{title}</div>}
        <div
          className="Body-2"
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />
        {hasToggle && (
          <FlexContainer className="items-align-center margT16">
            <div
              className={classnames('Subtitle-2', {
                format100: isProfile,
              })}
            >
              Start receiving emails?
            </div>
            <div className="toggleText Subtitle-2 padL12 padR18 whitespace-nowrap">
              {toggleText}
            </div>
            <Toggle
              checked={!!toggleStatus}
              className="emailToggle"
              onChange={checked => {
                onClickToggle(checked);
              }}
              ariaLabel={toggleText}
            />
          </FlexContainer>
        )}
      </FlexContainer>
      <div className="padL10" onClick={onClickClose}>
        {closable && <CloseIcon className="pointer"></CloseIcon>}
      </div>
    </FlexContainer>
  );
};

export default EmailNotificationView;
